import FreelancerTickets from './FreelancerTickets';

export default FreelancerTickets;

